import { SET_PAGE_SIZE } from "../enums";

export const pageSize = (state = 10, action) => {
    switch (action.type) {
        case SET_PAGE_SIZE:
            return state + 10;
        default:
            return state;
    }
};
